import { projectsDataEn, projectsDataAr } from "../data/projectsData";
import { useLanguage } from "../LanguageContext";

export default function ProjectDetailView({ navigate, selectedKey }) {
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);
  const projectsData = isAr ? projectsDataAr : projectsDataEn;
  const data = projectsData[selectedKey];
  if (!data) return null;

  return (
    <div className="view-enter min-h-screen flex flex-col">
      <div className="pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12 md:pb-16 px-4 sm:px-6 bg-gray-50 flex-grow">
        <div className="max-w-6xl mx-auto">
          <button
            onClick={() => navigate("projects")}
            className="text-neutral-600 hover:text-primary-600 mb-6 sm:mb-8 flex items-center gap-2 font-bold tracking-wide transition group"
          >
            <i className={`ph-bold ${isAr ? "ph-arrow-right group-hover:translate-x-1" : "ph-arrow-left group-hover:-translate-x-1"} transition-transform`} />
            {t("Back to Portfolio", "العودة إلى المحفظة")}
          </button>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            {/* Image Banner */}
            <div className="h-[250px] sm:h-[300px] md:h-[400px] bg-gray-900 relative">
              <img src={data.image} alt={data.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" />
              <div className="absolute bottom-4 sm:bottom-6 md:bottom-10 left-4 sm:left-6 md:left-10 right-4 sm:right-6 md:right-10">
                <div className="inline-block bg-primary-600 text-white px-4 py-1.5 rounded-md font-bold uppercase tracking-widest text-xs mb-4 shadow-lg">
                  {data.tagLabel}
                </div>
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-2 font-display">
                  {data.title}
                </h1>
                <p className="text-base sm:text-lg md:text-xl text-gray-300 font-light max-w-xl md:max-w-3xl">
                  {data.subtitle}
                </p>
              </div>
            </div>

            <div className="p-6 sm:p-8 md:p-10 lg:p-16 grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-16">
              {/* Summary */}
              <div>
                <h3 className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-4 sm:mb-6 flex items-center gap-3 font-display">
                  <span className="w-8 h-px bg-gray-300" />
                  {t("Project Summary", "ملخص المشروع")}
                </h3>
                <ul className="space-y-3 sm:space-y-4 text-gray-700 font-light text-sm sm:text-base md:text-lg">
                  {data.summary.map((item, i) => (
                    <li key={i} className="flex gap-4">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-600 shrink-0 mt-2.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Logistics */}
              <div className="bg-axion-accent p-4 sm:p-6 md:p-8 rounded-xl border border-gray-200 h-fit">
                <h3 className="text-sm font-bold tracking-wider text-primary-700 uppercase mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3 font-display">
                  <i className="ph-fill ph-truck text-2xl" />
                  {t("Logistics & Equipment", "اللوجستيات والمعدات")}
                </h3>
                <ul className="space-y-3 text-gray-700">
                  {data.logistics.map((item, i) => (
                    <li key={i} className="flex gap-3">
                      <i className={`ph-bold ${isAr ? "ph-caret-left" : "ph-caret-right"} text-primary-600 shrink-0 mt-1`} />
                      <span className="font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-12 sm:py-16 md:py-20 px-4 sm:px-6" style={{ backgroundColor: "rgb(17, 60, 111)" }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6 font-display text-white">
            {t("Need A Similar Project Delivery?", "هل تحتاج تسليماً لمشروع مماثل؟")}
          </h2>
          <p className="text-xl text-white/90 mb-10 font-light">
            {t(
              "Talk to our team about scope, schedule, and execution strategy.",
              "تحدث مع فريقنا حول النطاق والجدول الزمني واستراتيجية التنفيذ."
            )}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate("contact")}
              className="bg-white text-primary-700 px-10 py-4 rounded-xl font-bold text-lg hover:bg-primary-700 hover:text-white shadow-button transition-all transform hover:-translate-y-1"
            >
              {t("Contact Us", "تواصل معنا")}
            </button>
            <button
              onClick={() => navigate("projects")}
              className="border-2 border-white/60 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white hover:text-primary-700 transition-all transform hover:-translate-y-1"
            >
              {t("All Projects", "جميع المشاريع")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
